import {Component, EventEmitter, Input, Output} from '@angular/core';
import {CommonModule, NgClass} from '@angular/common';
import {BaseButtonComponent} from './base-button.component';
import {ServingUtil} from '../../utils/serving-util';
import {ThemeService} from '../../services/theme-service';

@Component({
  standalone: true,
  imports: [CommonModule, BaseButtonComponent],
  selector: 'app-circle-button',
  template: `
    <app-base-button
      [baseClass]="computedClasses"
      [disabled]="disabled"
      (onClick)="onClick.emit($event);"
    >
      <img *ngIf="imgUrl" [src]="getScaledImage()">
      <i *ngIf="icon && !imgUrl" [class]="iconClasses + ' ' + icon"></i>
    </app-base-button>
  `
})
export class CircleButtonComponent {
  @Input() imgUrl?: string | null;
  @Input() icon?: string;
  @Input() disabled: boolean = false;
  @Input() type: string = 'border';
  @Input() size: string = '8';
  @Input() fontSize: string = 'xs';
  @Output() onClick = new EventEmitter<MouseEvent>();

  constructor(private themeService: ThemeService) {}

  get computedClasses(): string {
    const classes = [
      'rounded-full',
      'flex',
      'items-center',
      'justify-center',
      'overflow-hidden', // Prevents the icon from overflowing the button
      'text-theme-primary',
      'transition-all',
      //Do not set bg-color here, it will be set in the type-specific classes!
    ];

    // Type-specific classes
    const typeClasses: { [key: string]: string } = {
      'border': 'border border-gray-300',
      'border2': 'border-2 border-theme-primary',
      'solid': 'bg-theme-surface2',
      'solid-border': 'bg-theme-surface2 border-2 border-theme-primary drop-shadow-lg',
      'solid-light': 'bg-theme-surface',
      'solid-light-shadow': 'bg-theme-surface drop-shadow',
      'glass': 'bg-gray-200/50 backdrop-blur-md',
      'round-image-only': 'rounded-full w-12 h-12 object-cover',
    };

    if (this.type in typeClasses) {
      let s= typeClasses[this.type];
      if (this.themeService.outlineColor) {
        s += ' border-theme-outline border-2';
      }
      classes.push(s);
    }

    // Size classes
    classes.push(`w-${this.size}`, `h-${this.size}`);
    return classes.join(' ');
  }

  get iconClasses(): string {

    let classes = `fas text-${this.fontSize}`;

    // Disabled state
    if (this.disabled) {
      classes = classes.concat(' ', 'opacity-30');
    }
    return classes;
  }

  getScaledImage() {
    const s = parseInt(this.size)*4*2
    if(!this.imgUrl) {
      return
    }
    //return this.imgUrl;
    //console.log('Original image:', this.imgUrl);
    const url =  ServingUtil.getDynamicImage(this.imgUrl, s, true, true);
    //console.log('Scaled image:', url);
    return url;
  }
}
